export default __webpack_public_path__ + "static/media/RenaultLifeWeb-Regular.af2a5ab5.woff";